import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungCottbus() {
  return (
    <CityPageTemplate
      city="Cottbus"
      slug="cottbus"
      intro="Cottbus im Strukturwandel – nutze staatliche Förderungen und smarte Geldanlage für Deine Zukunft."
      description="Unabhängige & digitale Finanzberatung für Cottbus: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
